import React from "react";
import { PageHeader } from "../../../components";

export default function SECRETARYGENERAL() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_SEC_GENERAL.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">Mrs. DAMILOLA IKPE </h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                  Damilola Ikpe makes history as the first Secretary General of Lagos Country Club, bringing her lifelong passion, leadership
                  , and deep-rooted commitment. As a second-generation member, Damilola grew up within the vibrant community of Lagos Country Club. Her dedication to the club's growth is reflected in her extensive history of volunteer service,
                  including:

                  Snooker/Billards Section: Secretary (2023 - 2026) and Committee Member (2020 - 2023)

                  Special Committees: Bar & Catering Committee (2023-2026), 

                  Youth Committee (2022 - 2025),

                  Children's End of Year Party (2023 - 2025) and the New Year Party Committee (2023 - 2025)

                  For Damilola, Lagos Country Club is a true family affair,

                  Beyond her contributions to LCC, Damilola is a highly respected professional in the aviation industry
                  with over 13 years of experience in Airport Business and Commercial Management.

                  Damilola masterfully balances her thriving career, academic pursuits, and family life, embodying the passion for excellence and service that defines Lagos Country Club.

                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
